import React, { FC } from 'react';
import InternshipCard from './InternshipCard';
import Header from './Header'


const Internships: FC = () => {
  return (
    <div>
      <Header />
      <InternshipCard />
    </div>
  );
};
export default Internships;
